import React from "react";
import { Link } from "react-router-dom";
import "../../../style/buttons.scss";
import { FINALIZE_PAGE } from "../../../app/routes";
import { useSelector } from "react-redux";
import { State } from "../../../app/store";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const BasketNavButton: React.FC = () => {
  const basketLength = useSelector((state: State) => state.basket.basketLength);
  const basketTotal = useSelector((state: State) => state.basket.basketTotal);
  
  const { t } = useTranslation();

  return (
    <React.Fragment>
      
   
      <Link
        to={FINALIZE_PAGE}
        className={
          basketLength === 0
            ? "button-basket medium padding-small"
            : "button-basket-active button-basket medium padding-small"
        }
      >
        <div className="flex-start-center">
          <HiOutlineShoppingBag className="icon" title={t("koszyk")} />
          <b>Przejdź do koszyka</b>
        </div>
        <strong className="flex-center-center">{basketLength}</strong>
      </Link>
    </React.Fragment>
  );
};

export default BasketNavButton;

